import { Card } from './card';
import { Checkbox } from './checkbox';
import { CloseButton } from './close-button';
import { FormLabel } from './form';
import { Input } from './input';
import { Menu } from './menu';
import { Modal } from './modal';
import { Radio } from './radio';
import { Select } from './select';
import { Switch } from './switch';
import { Table } from './table';
import { Textarea } from './textarea';

export const components = {
	Card,
	Checkbox,
	CloseButton,
	FormLabel,
	Input,
	Menu,
	Modal,
	Radio,
	Select,
	Switch,
	Table,
	Textarea,
};
